export default __webpack_public_path__ + "static/media/pag10.7d3d5e96.jpg";